module.exports = __webpack_public_path__ + "static/media/err_404.f00e0dc5.png";